import { ValidatorFn, Validators } from '@angular/forms';
import { PurposeOfFilingRegexPattern } from './purpose-of-filing-regex-patterns';

export const PurposeOfFilingValidatorConfig: {
    callSign: {
        default: ValidatorFn[];
        required: ValidatorFn[];
    };
} = {
    callSign: {
        default: [
            Validators.minLength(3),
            Validators.pattern(
                PurposeOfFilingRegexPattern.callSignFirstLetterPattern,
            ),
        ],
        get required(): ValidatorFn[] {
            return [Validators.required].concat(this.default);
        },
    },
};

export const PurposeOfFilingErrorMessages = {
    callSign: {
        pattern: 'Call sign must begin with either a "K" or a "W".',
        notFound:
            'Call sign was not found. Please check your entry and try again.',
    },
} as const;
